import React from "react";
import { TextField } from "@material-ui/core";

// TZ-795: accept international phone numbers. The old rigid
// "+19999999999" InputMask forced US/NANP (exactly +1 + 10 digits), so
// non-NANP numbers (e.g. UK +44) couldn't be entered at all. We now keep
// the input permissive — an optional leading "+" plus digits and the
// usual separators — and let the backend (User.canonicalize_phone)
// normalize whatever is typed into E.164. Canada/PR still work (they're
// +1 NANP) and any other country is now enterable too.
const sanitizePhone = (raw) => {
  let v = (raw || "").replace(/[^\d+()\-.\s]/g, "");
  // Left-trim first so a leading "+" (e.g. from a pasted " +44…") is the
  // first character — otherwise the next step would strip it.
  v = v.replace(/^\s+/, "");
  // Keep only a single leading "+".
  v = v.replace(/(?!^)\+/g, "");
  return v.slice(0, 20);
};

const MaskedPhoneInput = ({
  value,
  handleChange,
  disabled,
  error,
  helperText,
  required,
}) => {
  const onChange = (e) => {
    e.target.value = sanitizePhone(e.target.value);
    handleChange(e);
  };

  return (
    <TextField
      required={required}
      disabled={disabled}
      fullWidth
      helperText={helperText}
      id="phone_number_input"
      label="Phone"
      variant="outlined"
      name="phone_number"
      type="tel"
      placeholder="+1 555 123 4567"
      value={value}
      error={error}
      onChange={onChange}
      inputProps={{ maxLength: 20 }}
    />
  );
};

export default MaskedPhoneInput;
